import Ingressinho from 'assets/imgs/ingressinho.svg';
import * as styles from './EmptySearchResults.css';

interface EmptySearchResultsProps {
  title: string;
  subtitle: string;
  description?: string
}

function EmptySearchResults({ title, subtitle, description }: EmptySearchResultsProps) {
  return (
    <div className={styles.Container}>
      <Ingressinho width={80} height={80} className={styles.ImgStyle}/>
      <h3 className={styles.Title}>{title}</h3>
      <p className={styles.TextStyle}>{subtitle}</p>
      {description && <p className={styles.TextStyle}>{description}</p>}
    </div>
  );
}

export default EmptySearchResults;
